import {
  GET_BOOKS,
  SET_PAGE,
  SET_SEARCH,
  SET_BOOK_TYPE,
  SET_ORDER_BY,
  SET_SORT_BY,
  GET_RELATED_BOOKS,
  GET_RELATED_COURSES,
  GET_ALL_TUTORS,
} from "../../shared/constants/ActionTypes";
import moment from "moment";

const initialBooks = {
  books: [],
  related_books: [],
  related_courses: [],
  bookCount: 0,
  page: 1,
  search: "",
  bookType: "HARD-BOOK",
  sortby: "",
  orderby: "desc",
  tutors: [],
};

function booksReducer(state = initialBooks, action) {
  switch (action.type) {
    case GET_BOOKS:
      return {
        ...state,
        books: action.payload.books.map((book) => {
          return {
            ...book,
            updatedAtFormatted: moment(book.createdAt).format("ll"),
          };
        }),
        bookCount: action.payload.total,
      };
    case GET_RELATED_BOOKS:
      return {
        ...state,
        related_books: action.payload,
      };
    case GET_RELATED_COURSES:
      return {
        ...state,
        related_courses: action.payload,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case GET_ALL_TUTORS:
      return {
        ...state,
        tutors: action.payload,
      };
    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_BOOK_TYPE:
      return {
        ...state,
        bookType: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };

    default:
      return state;
  }
}

export default booksReducer;
